import React from 'react';
import { Check } from 'lucide-react';
import { PathSteps } from './PathSteps';
import { knowItems, pathSteps } from '../data/offer';
export function DevelopmentPath() {
  return <section className="py-24 px-4 bg-white border-t border-line" data-id="element-92" data-mp="i2njknf226zp">
      <div className="max-w-5xl mx-auto text-center" data-id="element-93" data-mp="i1vnzclgk99f">
        <h2 className="text-3xl md:text-5xl font-display font-extrabold text-navy mb-8" data-id="element-94" data-mp="e0tn6rbw7p5c">
          The Complete Rider Development Path
        </h2>
        <div className="mb-12" data-id="element-95" data-mp="3mizl9i82l8yx">
          <PathSteps steps={pathSteps} data-id="element-96" data-mp="3hi24na2pkmzj" />
        </div>
        <p className="text-xl text-muted mb-8" data-id="element-97" data-mp="3hjmyexh781wc">
          Instead of filling sessions with random drills, you know:
        </p>
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 text-left" data-id="element-98" data-mp="3qigr4cres84m">
          {knowItems.map((item, index) => {
          const last = index === knowItems.length - 1;
          return <li key={item} className={`flex items-center gap-3 rounded-xl px-5 py-4 font-display font-extrabold uppercase tracking-wide text-sm sm:text-base ${last ? 'bg-forest text-white' : 'bg-sand-light border border-line text-forest'}`} data-id="element-99" data-mp="15s9lvjqq52bx" data-mpi={index}>
                <Check size={18} strokeWidth={3} className={last ? 'text-seafoam' : 'text-seafoam-dark'} aria-hidden="true" data-id="element-100" data-mp="3ijsyfbiikv1w" />
                {item}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}